module.exports = __webpack_public_path__ + "static/img/login_bg@3x.bd32170.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/invite/login_bg@3x.png
// module id = z1aK
// module chunks = 1